import { frozenEnsembles, frozenEnsemble } from "./ensembleSnapshot";
import {
  ensembleRequestUrl,
  normalizeEnsemble,
  type EnsembleModel,
} from "rainowls-shared";

/** Dedicated ensemble endpoint; forecast-server credentials are never sent to it. */
export async function fetchEnsemble(
  latitude: number,
  longitude: number,
  model: EnsembleModel,
  signal: AbortSignal,
) {
  if (frozenEnsembles) return frozenEnsemble(model);
  const endpoint = import.meta.env.VITE_ENSEMBLE_API_URL || undefined;
  const response = await fetch(
    ensembleRequestUrl(latitude, longitude, model, endpoint),
    { signal },
  );
  if (!response.ok) {
    throw new Error(
      response.status === 429
        ? "The ensemble provider is busy. Please try again in a few minutes."
        : "Unable to load this ensemble. Please try again.",
    );
  }
  return normalizeEnsemble(await response.json(), model);
}
